import * as CarbonComponents from '@carbon/react';
export const Tile = CarbonComponents.Tile;
export const ClickableTile = CarbonComponents.ClickableTile;
export const ExpandableTile = CarbonComponents.ExpandableTile;
export const TileAboveTheFoldContent = CarbonComponents.TileAboveTheFoldContent;
export const TileBelowTheFoldContent = CarbonComponents.TileBelowTheFoldContent;
export const TileGroup = CarbonComponents.TileGroup;
export const RadioTile = CarbonComponents.RadioTile;
